export default __webpack_public_path__ + "static/faq_f3-5ac8ddd15940d81c540e62edac89581c.png";